import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SERVICE_EXTENSION_SERVICE } from 'ziti-console-lib';
import { ApiService } from '@netfoundry-ui/shared/services';
import { isEmpty } from 'lodash';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ServicesExtensionService } from '../services-extension/services-extension.service';

type ServiceTab = 'overview' | 'metrics' | 'dial-logs';
const VALID_SERVICE_TABS: ServiceTab[] = ['overview', 'metrics', 'dial-logs'];

@Component({
    selector: 'netfoundry-ui-service-form-extension',
    templateUrl: './service-form-extension.component.html',
    styleUrls: ['./service-form-extension.component.scss'],
    standalone: false
})
export class ServiceFormExtensionComponent implements OnInit, OnDestroy {
  private currentTabParam: ServiceTab = 'overview';
  currentNetwork: any = {};
  subscription = new Subscription();

  constructor(
    @Inject(SERVICE_EXTENSION_SERVICE) public svc: ServicesExtensionService,
    private apiService: ApiService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.apiService.currentNetwork.subscribe((currentNetwork: any) => {
        this.currentNetwork = currentNetwork;
      })
    );
    this.subscription.add(
      this.route.paramMap.subscribe((params) => {
        const tab = params.get('tab') as ServiceTab;
        this.currentTabParam = VALID_SERVICE_TABS.includes(tab) ? tab : 'overview';
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get activeTab(): ServiceTab {
    return this.showEntityTabs ? this.currentTabParam : 'overview';
  }

  get showEntityTabs() {
    return !isEmpty(this.svc?.formData?.id);
  }

  get entityId(): string {
    return this.route.snapshot.paramMap.get('id') || '';
  }

  get entityTabData() {
    return {
      resourceType: 'service',
      model: this.svc?.formData,
      networkId: this.currentNetwork?.id,
      networkGroupId: this.currentNetwork?.networkGroupId,
    };
  }
}
